// FAQData.js
export const faqData = {
    company: [
      {
        subheading: "Company",
        faqs: [
          {
            question: "Tell me about Maxiom Wealth",
            answer: `Maxiom Wealth is an equity and investment advisory was founded in 2016 (officially company name: Simply Grow Technologies Pvt Ltd).

Founded by Ram Medury and Manoj Trivedi from IIM Bangalore class of 1996-98, it has seen rapid growth, pioneering a zero touch, zero commission, zero brokerage investment advisory model.

We currently handle several hundred crores of 'assets under advisory'.

We are a SEBI Regd Corporate advisory (code INA200015583).`
          },
          {
            question: "How are Maxiom & Maxiom Wealth different?",
            answer: `MaxiomWealth.com is our focused equity advisory service, powered by technology and industry experts.

Maxiom is the core technology platform that helps in financial planning, goal planning and smaller ticket investments.`
          }
        ]
      },
      {
        subheading: "Team, Advisors",
        faqs: [
          {
            question: "Who are the advisors? Their background?",
            answer: `Ram Medury is the founder and CEO of Maxiom Wealth. He holds an MBA from IIM Bangalore. Ram’s career spans Finance, Investments and Technology (FIT) over 23 years. He has played different roles in sales, investments, account management and technology. He has incubated many greenfield units and skunkworks projects in all his corporate stints. Over the last five years has helped build a business in Wealth Management which is different from many incumbent high-fee and low-performance structures.

Manoj Trivedi is a member of The Institute of Chartered Accountants of India and holds a PGDM specializing in Finance & Strategy from IIM, Bangalore. He also holds an Advanced Diploma in Finance from ICFAI, is a member of the ICWAI. Manoj is an ideal blend of academics, services, professional practice and Entrepreneurship, with more than 30 years of experience spanning Investment Advisory, Management Consulting, Outsourcing and Offshoring of IT services, Project Finance and FinTech.`
          },
          {
            question: "How is your management different?",
            answer: `Both Manoj & Ram Kalyan Kumar Medury have 25+ years of experience in the industries such as (Banking, Finance, Technology, Startups) in leadership and executive roles. So connecting with portfolio companies and their stakeholders on practical matters is easier.

They are not the typical product pushers or analysts or wealth managers who typically do not have working experience in the companies they advice clients to invest in. This makes a difference in selecting the right companies and tracking their performance.`
          }
        ]
      }
    ],
    fee: [
      {
        subheading: "Advisory fee",
        faqs: [
          {
            question: "Any charges other than advisory fees?",
            answer: `We only charge advisory fees (taxes are extra). What you see is what you get.`
          },
          {
            question: "Do you charge exit load?",
            answer: `No there are no exit loads. You are free to withdraw your money at any point in time without any penalties.`
          },
          {
            question: "Is GST included in fee?",
            answer: `GST is not included in management fee it is added separately, as per regulations.`
          }
        ]
      },
      {
        subheading: "Fee",
        faqs: [
          {
            question: "What is fee structure?",
            answer: `The advisory fees are the cost of having your portfolio professionally managed by an Investment Advisor.

This is a standard advisory fee also called as service fee or management fee.

There may be a second element of outcome based fee linked to your portfolio performance above a certain level (called outcome). This allows you to spread the fee between an advisory part and an outcome linked part.`
          }
        ]
      },
      {
        subheading: "Fee Payment",
        faqs: [
          {
            question: "Can someone else pay my fees?",
            answer: `No. You must pay the advisory fees from your bank account only. As per regulation, we also need a copy of a cancelled cheque to establish that the payment recieved matches with the investor.`
          },
          {
            question: "Can I pay via UPI ?",
            answer: `Yes, you can pay fee via any UPI enabled app such as BHIM, PhonePe or Google Pay. The Virtual Private Address to enter would be simplygrow@icici

You may also pay by NEFT to Bank account 236405500225 having IFSC Code ICIC0002364.`
          },
          {
            question: "Can I pay advisory fee half yearly?",
            answer: `Yes fees can be paid half yearly.`
          },
          {
            question: "When to pay fees?",
            answer: `The advisory fees has to be paid on half-yearly basis; the exact amount depends on the plan you select.`
          }
        ]
      },
      {
        subheading: "Outcome Linked",
        faqs: [
          {
            question: "Are you promising happy outcomes?",
            answer: `A "desired outcome" is an indicative number if you wish to link a portion of the fees to an outcome. As an advisor, we do not guarantee that such a number can be met because nobody can predict market returns. Moreover SEBI does not permit RIAs to charge fees linked to performance on client agreements signed after 1 April 2021.

Having said that, the average three-year rolling returns of our portfolio from 2004 (historical backtest) is at 31% CAGR. Over a three year period this amounts to more than a 100% absolute return. Since our portfolio went live in Aug 2019, it returned 95.4% (until May 2021). During the same time period, Nifty returned 42%.`
          },
          {
            question: "Can I defer fee linked to outcome?",
            answer: `As per regulation SEBI does not permit RIAs to charge fees linked to performance on client agreements signed after 1 April 2021. [An portion of fee can be linked to your portfolio growth above a certain level (called desired outcome).]`
          },
          {
            question: "If I dont sell, how will you calculate performance?",
            answer: `The performance is calculated including realised and unrealised gains. [The comparative Hurdle rate is also calculated on a Cumulative basis.

Any shortfall vs the hurdle has to be 'made up' in the next term before we can become eligible for any outcome linked fees.]`
          }
        ]
      },
      {
        subheading: "Plans",
        faqs: [
          {
            question: "What plans do you offer?",
            answer: `We offer 1 year, 3 year lumpsum and 3 year SIP plans. The actual plan may vary based on your requirements and the regulations we need to comply with.`
          },
          {
            question: "Can i spread my investment?",
            answer: `We offer 1 year, 3 year lumpsum and 3 year SIP plans. The actual plan may vary based on your requirements and the regulations we need to comply with.`
          },
          {
            question: "Can i spread my investment?",
            answer: `You can invest a lumpsum and we will stagger it based on your situation and market scenario. Usually staggered lumpsums are completed over 5 to 6 weeks with weekly installments.`
          },
          {
            question: "Where can I make ad-hoc investments?",
            answer: `You can invest more than the initial planned amount. We will reconcile the books on a monthly basis and any fee differential will be reflected in the fee ledger.

All fees are transparent with detailed drill down available in the online reports.`
          },
          {
            question: "Can I make ad-hoc investments?",
            answer: `You can invest more than the initial planned amount. We will reconcile the books on a monthly basis and any fee differential will be reflected in the fee ledger.

All fees are transparent with detailed drill down available in the online reports.`
          },
          {
            question: "Can you customise a plan for me?",
            answer: `Depending on the amount invested our advisor can look at customising a plan for your unique requirement.`
          },
          {
            question: "Can I invest via STP?",
            answer: `You can park your surplus in a liquid ETF (liquidbee) and we will help you with a weekly or monthly redemption from that fund with a simultaneous investment in our recommended equity portfolio.`
          },
          {
            question: "How does SIP work?",
            answer: `You sign up for a three year term and plan to invest every month. We will help you with monthly investments in our recommended portfolio.

The portfolio may change depending on changes to our model portfolio based on quarterly business results and other factors. Our system automatically takes care of adjusting the quantities of various stocks and helps you rebalance your portfolio.`
          }
        ]
      }
    ],
    how_is_Maxiom_Different: [
      {
        subheading: "How is Maxiom different",
        faqs: [
          {
            question: "How is Maxiom different from PMS/MF?",
            answer: `Maxiom Wealth is contact less on your invested money; we never touch or hold it, because we do not access/operate your bank account or demat account. This makes it very safe.

In case of others you end up handing over custody of your money to them to manage.

With Maxiom Wealth, there are no brokerages or other loads. What you see is what you get: zero hidden costs, zero brokerages. The fees are transparent and payable over the table. There is no lock in nor exit loads.

The performance track record of Maxiom Equity Wealth Long portfolio is published daily on our website. You can easily compare it with any PMS or mutual fund. Audited portfolio statements are available upon request.`
          }
        ]
      },
      {
        subheading: "Portfolio",
        faqs: [
          {
            question: "How is your portfolio different?",
            answer: `Our portfolio advisory is neither over-concentrated nor over diversified. Having a handful of stocks may increase risk and lead to big drawdowns.

Many funds tend to over diversify by running into 50+ stocks. Some funds also mimic the index and add little value to the discerning investor. This dilutes returns.

We use deep technology in portfolio design, execution and tracking that make investing safe, smart and convenient for you.`
          }
        ]
      },
      {
        subheading: "Principles",
        faqs: [
          {
            question: "Your advisory principles & values",
            answer: `In addition to being a SEBI Registered Investment Advisory company, we follow these clear & clean principles.
These are like our ten commandments.
1. Do not take custody of clients money
2. Do not take custody of clients share or units
3. Do not take money off client portfolio via hidden fees
4. Eliminate incentives to create brockerage or transaction fees
5. Do not constrain client with exit loads
6. Do not impose lockin on clients fund
7. Flexible and can be personalised
8. Portfolio selection is unbiased because of use of data/technology
9. No hidden costs => Honest Advice
10. We invest in the same portfolio ourselves`
          }
        ]
      }
    ],
    investment_Philosophy: [
      {
        subheading: "Diversification",
        faqs: [
          {
            question: "Are you too concentrated (12-18 picks)?",
            answer: `The quality of DNA which helps deliver consistent and healthy fundamentals of our portfolio companies is the biggest source of reduction in volatility of stocks in this portfolio.`
          },
          {
            question: "Do you pick across market caps?",
            answer: `Our portfolio is a diversified with exposure spread across largecap, midcap and a thin slice of smallcap.

We usually do not pick beyond the Top 350 stocks, ie deeper side of small cap because of potential governance issues.`
          },
          {
            question: "Do you invest in derivatives?",
            answer: `We don't invest in derivatives. We avoid leverage in investments.

We only suggest delivery/cash market transaction.`
          }
        ]
      },
      {
        subheading: "Investment Philosophy",
        faqs: [
          {
            question: "What is your investment philosophy?",
            answer: `Our Investment Philosophy is called Roots & Wings.

Roots aim to preserve wealth by selecting companies with low debt, consistent ROE/ROCE & promoter integrity.

Wings aim to increase prosperity by identifying growing companies (sales/profit/cash flows) with staying power in their markets.`
          }
        ]
      },
      {
        subheading: "Process",
        faqs: [
          {
            question: "Dont small caps grow faster?",
            answer: `Small caps may be perceived as growing faster. However reality is that a vast majority of the small cap companies fail to scale due to promoter integrity or incompetence.

The BSE small cap index has delivered nearly 0% growth between the years ending 2007 and 2019.

Good quality large and mid cap companies (top 250) have 'run the marathon' and proven themselves. They have figured out the right orgn structure, team and distribution franchise required to grow. And they keep growing.

To get the best of these we tend to focus on the top 250 plus the next 100 odd larger 'small cap' companies for our JEWEL portfolio.`
          },
          {
            question: "Do you track valuations? | If a stock gets expensive, will you sell it?",
            answer: `An 'expensive company' may appreciate its share price for several years. Conversely a 'cheap' company may further detoriate in fundamentals leading to wealth destruction.

Our extensive studies have down that expensive-ness and stock price growth are not necessarily related.

Having said that our quarterly rebalancing naturally reduces exposure to run up stocks. To take a cricketing analogy, this is done primarily to build a team and not just rely on one star batsman.`
          },
          {
            question: "Can you throw some light on backtesting?",
            answer: `We have thoroughly tested out Roots & wings investment philosophy between 2004 and 2019 before launching it. We have done this basis Balance sheet and PL data of last 21 years.

Needless to say, our historical and live results have converged thereby validating our investment philosophy and technology algorithms.`
          },
          {
            question: "How often do you churn your portfolio?",
            answer: `We review the portfolio quarterly. We check if the fundamentals have changed as per Roots & Wings.

We also check for any governance issues and revisit assumptions made during due diligence.

We then advice you to increase/decrease/add/avoid specific stocks and the respective quantities.`
          },
          {
            question: "How do you do human due diligence?",
            answer: `Our data science algorithms do the majority of the heavy lifting. The Roots & Wings parameters and their derived metrics, time series ratios, ratios vs economic indicators are all computed.

Once a shortlist is arrived at, our core advisory team comprising of Manoj Trivedi and Ram Medury reach out to the industry network to understand how these companies are reacting to a fast chaining environment. If their moats are in tact, if their pricing power is enduring, risks in their business model and most importantly if the management teams are still committed to running a tight ship and have aggressive plans about the future.`
          },
          {
            question: "Are you against 'Buy & Hold'",
            answer: `Buy and hold is risky because a particular company/sector may go bad fairly quickly due to promoter issues, regulatory changes or any other reason. Rebalancing based on quarterly results is a must to nurture the portfolio. This strategy has given us a 30% avg CAGR over the last decade (disclaimer: past performance or backtests cannot predict future).

Since our portfolio went live in Aug 2019, it returned 95.4% (until May 2021). A hold only approach on the initial portfolio would have returned 53.20%. We can share audited reports/portfolio details upon request.
Note that during the same time period, Nifty returned 42%.`
          }
        ]
      },
      {
        subheading: "Roots",
        faqs: [
          {
            question: "How to avoid \"Chor\" promoters?",
            answer: `The biggest success factor for a companies health is the management's dedication and commitment to there shareholders.

Conversely the biggest risk is a management team that is not deeply interested or worse milks a company dry.

We check a copmany's shareholding pattern before selecting it. We also check if promoters have pledged away too many shares.

We prefer to be paranoid about corporate governance and have exited companies which showed symptoms of mal-intent. Eg: a Pharma company where CFO was indicted by the regulator.`
          },
          {
            question: "How does ROOTS preserve wealth?",
            answer: `Roots aim to preserve wealth by selecting companies with low debt, consistent ROE/ROCE & promoter integrity.

• We prefer to invest in businesses that carry very low debt. This means that their growth is fueled by their customers and through internal accruals.

• We like companies that consistently reward their shareholders through high levels of Return on Equity, Return on Capital Employed and Return on Assets. This signals not only an efficient business but also one that is shareholder friendly.

• We like promoters who demonstrate both skin-in-the-game and soul-in-the-game. Such promoters retain significant ownership in their business, which prevents the ‘agency problem’.

• We like companies that have already run the marathon and have demonstrated stamina. As a corollary, we avoid nano caps, micro caps and baby caps because the intent is to preserve capital first and not be exposed to risks stemming out of promoter integrity (or lack of it).`
          },
          {
            question: "Why are you averse to debt?",
            answer: `A company with high debt must honour its interest payments. In a bad economy if the revenues are hit, cost of interest payment only rises. This increase mortality of a company. Some examples are Cafe Coffee Day, 3i Infotech.`
          }
        ]
      },
      {
        subheading: "Timing",
        faqs: [
          {
            question: "Do you invest based on P/E ?",
            answer: `P/E multiples and PEG ratios do not adequately factor in the longevity of a business. A business may deliver returns on capital employed, higher than the cost of capital for several decades.

Hence an 'expensive company' may appreciate its share price for several years. Conversely a 'cheap' company may further detoriate in fundamentals leading to wealth destruction.`
          },
          {
            question: "When do you exit a stock?",
            answer: `We use proprietary technology to review the portfolio businesses on numerous performance parameters such as sales growth, profit growth, debt levels, ratios etc. Any slippage is promptly addressed by reducing or removing the stock's exposure.

We also check for any governance issues and revisit assumptions made during due diligence.

We then advice you to increase/decrease/add/avoid specific stocks and the respective quantities.`
          },
          {
            question: "When do you move to cash?",
            answer: `Our team of experts reviews the market situation and based on your risk profile may suggest on moving partially to cash.

This is only a tactical move. Many investors with adequate asset allocation already in place stay fully invested in the equity portfolio we advise.`
          },
          {
            question: "Do you time the market?",
            answer: `We do not believe we can time either market movements or predict share price movements. Staying invested through ups and downs has proven to be the best strategy to build wealth.

Moreover, the share prices of the kinds of companies that we hold in our portfolios, have had a low correlation with the broader market movements.`
          }
        ]
      },
      {
        subheading: "Wings",
        faqs: [
          {
            question: "How does WINGS tap growth?",
            answer: `Wings aim to increase prosperity by identifying growing companies (sales/profit/cash flows) that are resilient and have pricing and staying power in their markets.

• We like companies that have a huge runway of growth ahead of them. Usually they tend to grow 1.5 to 3 x times that of the GDP Growth.

• We prefer companies that possess significant operating cash flows. This also indicates that their growth is real, and not manufactured.

• Companies that are dominant in their markets and continue to hold good Market Share are preferred.`
          },
          {
            question: "What growth metrics do you track?",
            answer: `We track growth in revenues, profits, operating income, cashflows. We also monitor market share of the company in its sector.

The best companies grow well in all these dimensions.`
          },
          {
            question: "How do you track resilience?",
            answer: `Companies whose share prices fall faster than the index in a bear market are not preferred. Conversely companies that rise faster during a recovery phase are preferred.

A combination of these reflects resilience.`
          },
          {
            question: "Why is business growth important?",
            answer: `We invest in a 'share' of a business because we expect it to grow. The share price reflects the current estimate of the profit stream a company. Without growth the share price will not rise. We prefer companies that grow steadily and faster than their sector.`
          }
        ]
      }
    ],
    Maxiom_Operating_Model: [
      {
        subheading: "Account Opening",
        faqs: [
          {
            question: "Do i need to open a new demat account?",
            answer: `You can link any existing demat account (in case of Zerodha, Upstox). You may continue to use any demat account you wish to as well.

To keep things clear, we recommend that you setup a new demat account for the equity portfolio that we advise you on.`
          },
          {
            question: "What if i dont have a demat account?",
            answer: `You can open a demat account online with either Zerodha or Upstox or any other brokerage. It takes only 5-10 minutes. You get the user name and password over email and can start operating the next day.`
          },
          {
            question: "What documents do i need to signup?",
            answer: `We need copies of your PAN, address proof and a cancelled cheque. We have online forms and there is no need to print anything.`
          },
          {
            question: "How long to open the account?",
            answer: `The formalities to open with Maxiom Wealth take only 5-10 minutes.`
          },
          {
            question: "Which demat account to use?",
            answer: `The Investor can use any Demat account at per their wish.

You may wish to use a zero brokerage demat accounts such as Zerodha, Upstox. However the choice is yours.

All we need is for you to email us the contract note after executing the investments, so that we can track your portfolio.`
          }
        ]
      },
      {
        subheading: "Advisory Service",
        faqs: [
          {
            question: "Can you consolidate my investments?",
            answer: `We can help advise you on your overall portfolio. We have analytics covering all mutual funds and can advise on how to optimise your fund portfolio.

We can help you switch to direct equity and direct mutual funds as part of the consolidation.

There is no separate fee for this if you sign up with our Maxiom Wealth advisory service.`
          }
        ]
      },
      {
        subheading: "Contract",
        faqs: [
          {
            question: "Can the contract have multiple parties?",
            answer: `The investment advisory agreement will be on the name of an individual or a company/partnership.

In case of individuals, you are free to execute the advice in your joint demat account.`
          },
          {
            question: "Can we advise on third party portfolios?",
            answer: `No. We need to adhere to KYC norms and can advice only on the portfolio of clients who are signed up with our company for advisory services.`
          }
        ]
      },
      {
        subheading: "Equity vs Bitcoin",
        faqs: [
          {
            question: "Why not invest in Bitcoin?",
            answer: `Bitcoin has been on people's minds given its massive growth. While cryptocurrencies are good technology innovations, they will inevitably face pressure from governments and financial institutions.

Bitcoin has constraints such as very high volatility and is not a store value of money (like gold is).

Many Central banks (like RBI) are already working on their own versions of cryptocurrencies to "compete" with Bitcoin.`
          }
        ]
      },
      {
        subheading: "Equity vs FD",
        faqs: [
          {
            question: "Why not invest in Fixed Deposits (FD)?",
            answer: `Fixed deposits may appear safe but the post tax interest hardly beats inflation. So you may lose money over time.

Banks make more money than FD investors, good businesses that borrow money from such banks generate even higher returns. Investing in the best of such good businesses has proven to generate superior returns.`
          }
        ]
      },
      {
        subheading: "Equity vs Gold",
        faqs: [
          {
            question: "Why not invest in Gold?",
            answer: `Gold acts as a good hedge for investments; ie rises in value when there is uncertainty or crisis. However investing in Gold for appreciation may not pay off in the long run because both stocks and bonds have outperformed on average.`
          }
        ]
      },
      {
        subheading: "Equity vs Real Estate",
        faqs: [
          {
            question: "Why not invest in Real Estate",
            answer: `Real estate is good to the extent of one residential property. Beyond that lack of liquidity, security and maintenance hassles outweigh possible gains. From a long term growth stand point, RE has not done as well as equities.`
          }
        ]
      },
      {
        subheading: "Financial Planning",
        faqs: [
          {
            question: "How can we do SIP in this model?",
            answer: `Investor gets to invest in the portfolio every month as suggested by the advisor. It is reviewed every quarter just like any other investment.`
          },
          {
            question: "Do you offer a financial planning tool?",
            answer: `We can help with you a financial plan. We have an online tool on our web app and mobile app that makes goal planning and tracking very simple.`
          }
        ]
      },
      {
        subheading: "Outside Portfolios",
        faqs: [
          {
            question: "Can you advise me on other stocks?",
            answer: `We can provide you with onetime advice on what to do with stocks you are currently holding outside our advisory portfolio.

For this you need to forward your NSDL Consolidated Account Statement (eCAS) that is emailed to you by NSDL. You can also send us a pdf/xls or any other listing of the stocks (with ISIN codes preferably) and quantities.`
          }
        ]
      },
      {
        subheading: "Taxes",
        faqs: [
          {
            question: "What are taxes on equities?",
            answer: `In equity investments taxation is simple: 15% tax on short term capital (when held less than one year) and 10% tax on long term capital gains.`
          }
        ]
      }
    ],
    Performance: [
      {
        subheading: "Getting Started",
        faqs: [
          {
            question: "How do i get started with you?",
            answer: `It is easy to start with Maxiom Wealth. You can open your account online (5-10 minutes), link your demat account (1 minute).

As per regulation you must review/sign the agreement online and pay the fees. Then you are ready to start investing.`
          }
        ]
      },
      {
        subheading: "Making investments",
        faqs: [
          {
            question: "Do i need to transfer my stocks to you?",
            answer: `You can use the existing stocks as your initial corpus. We will advise you what to sell and what to retain.

You need not transfer any stocks to us because we do not retain custody of your stocks or cash at any time.`
          },
          {
            question: "How is demat integration zero touch?",
            answer: `We use technology to push the order basket to the demat account operator. In this way though we do not hold your stocks, we can still help you make changes to your portfolio.`
          },
          {
            question: "Do you facilitate investments?",
            answer: `Though we dont hold custody of your stocks, we do help you invest in a safe and convenient way.

We have integrated our app with some leading demat operators like Zerodha, Upstox. You can choose your own Demat account and there is no compulsion.`
          },
          {
            question: "Do you optimise my taxes?",
            answer: `One of our value adds is to optimise taxation for your investments. We try to identify stocks/funds that can be sold when taxation is in your favor.

For example if a stock is at a show term unrealised loss of 100 whereas another is at a short term realised gain of 100, then selling the former helps optimise your tax. This is an approach for tax-loss harvesting.`
          }
        ]
      },
      {
        subheading: "Operations",
        faqs: [
          {
            question: "How do i buy and sell ?",
            answer: `We will send you a link which takes you to the Maxiom Wealth app; If you use Zerodha or Upstox then the transactions are prefilled for you; you simply need to review and confirm.

If you use other demat accounts, then we send you an e-mail with the list of stocks to buy/sell along with the quantities.`
          },
          {
            question: "Is there any contract?",
            answer: `Please note that an agreement and formal payment are mandatory as per norms. Without that one cannot get any investment advice.`
          },
          {
            question: "Is advisory different for NRIs?",
            answer: `The core investment advisory is exactly the same. Some equities may be limited for NRIs based on the SEBI guidelines. In such situations, Maxiom Wealth will offer a substitute stock to be purchased.`
          },
          {
            question: "What are tax implications for an NRI ?",
            answer: `It would be the same as it is for equity investments. This comes to a 15% tax on short term capital (when held less than one year) and 10% tax on long term capital gains.`
          },
          {
            question: "Can i hold other stocks in the demat?",
            answer: `To keep things simple, we strongly recommend that you do not hold any other stocks in the demat account that we advise you upon.`
          },
          {
            question: "Do you have lock in?",
            answer: `There is no lock in with Maxiom Wealth investments. You are free to exit any time you wish to without any exit charges.`
          }
        ]
      },
      {
        subheading: "Plans",
        faqs: [
          {
            question: "Can I bring in additional funds later?",
            answer: `Yes, You can invest additional amount as per your requirement.

We support lumpsum anytime, staggered lumpsums over time, or standard 3-year SIP plans.`
          },
          {
            question: "How can we do SIP in this model?",
            answer: `Investor gets to invest in the portfolio every month as suggested by the advisor. It is reviewed every quarter just like any other investment.`
          },
          {
            question: "What is the minimum investment?",
            answer: `The minimum investment for an annual lumpsum is 25 lakhs. For a three year lumpsum it is Rs 10 Lakh.

For a Systematic Investment Plan it is a monthly installment of Rs 50,000 over three years.`
          },
          {
            question: "Will my portfolio be unique?",
            answer: `Regardless of the amount invested, every client (including the founders) have the same portfolio.

We can make some changes to address compliance requirements of the investors (eg: not investing in their employer, or having arms length relationship with some businesses etc).`
          }
        ]
      },
      {
        subheading: "Risks",
        faqs: [
          {
            question: "What are the rules governing you?",
            answer: `Registered Investment adivosrs are governed by SEBI Regulations. RIAs are either individual or corporate.

Corporate RIAs need to adhere to stricter regulations and compliance requirements which makes investing safer for the investor. Maxiom Wealth is a corporate RiA with the code INA200015583.`
          },
          {
            question: "Is it safe to invest with your advice?",
            answer: `We advice you on specific stocks to invest once you subscribe to our advisory. We do not hold your stocks and funds with us at any time. We do send a portfolio update every 3 months with a rationale for any changes.`
          },
          {
            question: "Is investing in direct equity risky?",
            answer: `Most things in life carry some risk. Investing in equities also carries risk because you buy a share of a business expecting it to deliver profits and grow.
Flying an aeroplane is largely safe today due to systems and trained pilots. Similarly investing when done with industry experts and a clean model (no custody, zero brokerage) reduces risk.
Using a proven investment philosophy such as Roots & Wings to eliminate shady companies, weak businesses also help better returns than other alternatives.`
          },
          {
            question: "Do you also follow your advice?",
            answer: `Yes our founders also invest in the same portfolio. This gets audited every quarter.`
          }
        ]
      },
      {
        subheading: "Support",
        faqs: [
          {
            question: "How to manage joint holder in demat?",
            answer: `You can contact customer service of the demat operator for any changes to the demat account, sending power of attorney, adding or modifying nominee etc

For upstox, please email support@upstox.com ad for Zerodha please email support@zerodha.com`
          },
          {
            question: "What are taxes in equity investments?",
            answer: `As an RIA advisory, we perform in a fiduciary capacity. The invsetor's tax liability is just like a direct equity investor (or equity mutual fund).

Investor should consult a tax advisor for any tax planning related queries. Since we do not keep custody, you are advised to take the tax/gain reports from the demat operator. We provide FAQs and videos on how to get this done from various demats that we integrate with.`
          },
          {
            question: "How do you track my investments?",
            answer: `We do not have access to your demat account. Hence we have a proprietary technology platform which tracks your portfolio only if you share the information.

You will need to share the contract note of the day when you make the transaction. You can easily setup an autoforward rule on your email inbox (eg: gmail filter) to send it to us.`
          },
          {
            question: "I am not in your city. Is it convenient?",
            answer: `All our process are digitised including onboarding, agreement signatures, payments, portfolio advisory, quarterly reports, execution, tracking etc.;

You can start remotely from any place and we support your video call (zoom, webex, etc). You can always connect with the management of the company.

Since we never touch your money or stocks/units, it is safe. We adhere to SEBI's strict code of conduct for Registered Investment Advisors.`
          },
          {
            question: "How do I see my portfolio performance?",
            answer: `Get technology enabled service and tracking at your fingertips.

You can always track the portfolio performance on the Maxiom Wealth App available on App Store, Playstore and as a Web App. Anytime and anywhere.

Our technology platform assures you of 100% transparency in billing that assures best value for low fees.`
          }
        ]
      }
    ],
    Portfolio: [
      {
        subheading: "Audited Report",
        faqs: [
          {
            question: "Can you share audited performance?",
            answer: `Yes - we audit the promoter's portfolio every other quarter and can share it upon request.`
          },
          {
            question: "How can i trust your numbers?",
            answer: `Since 2019, we have the audited reports of the portfolio for your reference.

We have backtested the portfolio from 2004 till 2019. If you are interested, we can share the portfolio holdings, allocation percentages along with rationale during this backtest period.`
          }
        ]
      },
      {
        subheading: "Performance",
        faqs: [
          {
            question: "Whats your performance track record?",
            answer: `Since our portfolio went live in Aug 2019, it returned 95.4% (until May 2021). During the same time period, Nifty returned 42%. We can share audited reports/portfolio details upon request.`
          },
          {
            question: "What returns can i expect?",
            answer: `SEBI regulations prohibit any projection of future returns or giving any assurance.

To get an idea of returns that equity markets have generated so far, you can see how Nifty 50 Total Returns Index (which includes dividends) has performed. An average three year return measured every 3 months (also calling rolling returns) between Nov 2004 and May 2021 has been 13.80%. Maxiom Wealth's JEWEL (long term, top 350 cos) strategy when backtested on same timeline has given about 31.66%. You can check our audited portfolio for actual returns since Aug 2019.

You can expect in general, that equities will generate better returns than bank deposits or other asset classes over the long term.`
          },
          {
            question: "What if markets falls badly?",
            answer: `Markets cannot be predicted. Global Financial Crisis in 2008-09 and Corona in 2020 are prime examples.

However equities have always bounced back. We have data on how our portfolio has performed in different bear markets in the last decade. We have seener lesser drawdown & faster recovery.`
          }
        ]
      },
      {
        subheading: "Holdings",
        faqs: [
          {
            question: "How do you treat dividends?",
            answer: `We track the dividends recieved on the stocks in your portfolio. Since we dont keep custody we cannot make fresh transactions on your behalf.

Iit is assumed that the dividends are reinvested in your portfolio for growth. You are advise to 'add funds' in your demat account equivalent to the dividends received once every 2-3 months.`
          }
        ]
      },
      {
        subheading: "Portfolio",
        faqs: [
          {
            question: "What are your sample top holdings?",
            answer: `We hold a mix of large cap, mid cap and a thin slice of small cap companies. In the large cap space, we have held (or hold) companies like Bajaj Finance, Asian Paints. In the mid-cap space, companies like Atul, Coforge and in the small cap space companies like Canfin Homes.

The common thing about these companies is that they meed the Roots & Wings Investment Philosophy of Maxiom Wealth.`
          }
        ]
      }
    ],
    technology: [
      {
        subheading: "Execution",
        faqs: [
          {
            question: "How does technology aid in execution",
            answer: `As an advisory, we do not get into holding stocks or funds. We assist in tech integration with leading demat accounts.

After the selection exercise, we use dynamic allocation algorithms to size your portfolio. Sizing is done with an aim to optimise growth and reduce volatility.

Seamless execution updates portfolios while keeping emotions in check. This use of tech makes investment easy and convenient for you.`
          }
        ]
      },
      {
        subheading: "Technology",
        faqs: [
          {
            question: "How do you pick stocks using algos?",
            answer: `We deploy data science systems to crunch the annual and quarterly numbers of thousands of businesses. We use proprietary technology to review the portfolio businesses on numerous performance parameters such as sales growth, profit growth, debt levels, ratios etc.

We analyse several hundred stocks on these thousands of data points (base and derived). Our data science algorithms help assign suitable weights to the parameters dynamically. Machine learning algorithms help fine tune selection parameters.

They learn over time and vary based on the economic context.These have given good results in decade+ backtest as well as in live deployment across years.`
          }
        ]
      }
    ],
    // Add more categories as needed
  };





  
  export default faqData;